import { IStorage } from './index';

export class LocalStorage implements IStorage {
    public getItem(key: string) {
        return localStorage.getItem(key);
    }

    public setItem(key: string, value: string) {
        localStorage.setItem(key, value);
    }

    public removeItem(key: string) {
        localStorage.removeItem(key);
    }
}